import { RequestQuery } from '@/data/types/RequestQuery';
import { RequestParams } from 'integration/generated/transactions/http-client';
import { transactionsClubdp, transactionsExtendedZone } from 'integration/generated/transactions';
import { useSettings } from '@/data/Settings';
import { getClientSideCommon } from '@/data/utils/getClientSideCommon';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { useExtraRequestParameters } from '@/data/Content/_ExtraRequestParameters';
import { useCallback } from 'react';
import { useNotifications } from '@/data/Content/Notifications';
import { TransactionErrorResponse } from '@/data/types/Basic';
import { processError } from '@/data/utils/processError';

const extendedZoneValidateFetcher =
	(pub: boolean) =>
	async (storeId: string, zipCode: string, query: RequestQuery = {}, params: RequestParams) => {
		const res = await transactionsExtendedZone(pub).validateExtendedZone(storeId, zipCode, query, params);
		return res;
	};

export const useExtendedZoneValidate = () => {
	const { settings } = useSettings();
	const router = useNextRouter();
	const { storeId } = getClientSideCommon(settings, router);
	const params = useExtraRequestParameters();
	const { notifyError } = useNotifications();

	const validateExtendedZone = useCallback(
		async (zipCode: string, orderId: any) => {
			try {
				const response = await extendedZoneValidateFetcher(true)(storeId, zipCode, {orderId}, params);
				return response;
			} catch (error) {
				notifyError(processError(error as TransactionErrorResponse));
				return null;
			}
		},
		[params, storeId, notifyError]
	);

	return {
		validateExtendedZone,
	};
};
